import { MotivationUtil } from 'kuaidong-model'
import { RouteConfig } from 'vue-router'

const Index = () => import('./2025/summer/index.vue')
const Winners = () => import('./2025/summer/winners.vue')

export const indexRoute: RouteConfig = {
  path: '/tzy/motivation-point/mall/2025/summer',
  name: 'tzy_motivation_point_mall_2025_summer',
  redirect: { name: MotivationUtil.pointActivityCenterRouteName },
  // component: Index,
  // props: (route) => ({ ...route.query, ...route.params }),
  // meta: {
  //   title: '暑假作业大作战',
  // },
}

export const winnersRoute: RouteConfig = {
  path: '/tzy/motivation-point/mall/2025/summer/winners',
  name: 'tzy_motivation_point_mall_2025_summer_winners',
  component: Winners,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '中奖名单公示',
  },
}

export default [indexRoute, winnersRoute]
